
















import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IZone } from "../../models/interfaces/zone/zone.model.interface";

@Component({
  components: {}
})
export default class ZoneUrlToolTip extends Vue {
  @Prop() public zone: IZone;

  private show: boolean = false;

  public showModal() {
    this.show = true;
  }

  public hideModal() {
    this.show = false;
  }
}
